import { useAuth } from "../auth/AuthProvider"
import { useEffect, useRef, useState } from "react"
import { PiChargingStationFill, PiGasPumpFill } from "react-icons/pi"
import { ProgressSpinner } from "primereact/progressspinner"
import { ReactComponent as EletropostoIcon } from '../images/eletroposto.svg';
import { MdElectricCar } from "react-icons/md";
import { HeaderType } from "../components/Title"
import { MenuItem } from "../components/Menu";
import * as API from '../services/API';
import { ProgressBar } from "primereact/progressbar";
import { GiPlug } from "react-icons/gi";
import { GrStatusInfo } from "react-icons/gr";
import {FaPlug } from "react-icons/fa";
import { BsFillPlugFill } from "react-icons/bs";
import { HiInformationCircle } from "react-icons/hi2";
import { CardEstacao } from "../components/Card";
import { Button } from "primereact/button";
export type PlugueType = {
    url: string
    id: string
    nome: string
}

export type ConectorType = {
    url: string
    id: string
    identidade: string
    plugue: any
    estacao: string
    start_url: string
    body_request: string
}

export type EstacaoType = {
    url: string
    id: number
    nome: string
    identidade: string
    conectores: Array<ConectorType>
    status: StationStatus
    token_url: string
    body_request: string
}

export type StationType = {
    id: string
    identity: string
    label: string
    connectionupdate: Date
    connected: boolean
    statecode: string
    statelabel: string
    description: string
}

export type StationStatus = 'LIVRE' | 'OCUPADO' | 'ONLINE' | 'OFFLINE'

type Props = {
    index: number,
    setIndex: Function,
    estacao: EstacaoType | null,
    setEstacao: Function
    estacoes: Array<EstacaoType>
}

export const StationHeader = (): HeaderType => {
    return {
        title: "Estações",
        subtitle: `Olá ${useAuth().profile?.nome?.split(' ')[0]}`,
        icon: <PiChargingStationFill size={40} style={{ marginLeft: 10, marginRight: 5 }} />
    }
}
export const StationMenu = (): MenuItem => {
    return {
        icon: <PiChargingStationFill size={32} />,
        label: 'ESTAÇÕES'
    }
}
const Station = (props: Props) => {
    const [loading, setLoading] = useState(false)
    const [loadingStatus, setLoadingStatus] = useState(false)
    //-1: Rejected
    //0: Button
    //1: Peding
    //2: Connecting
    //3: Charging
    // const [estacoes, setEstacoes] = useState<Array<EstacaoType>>([])

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                {loading ?
                    <>
                        <ProgressSpinner style={{ width: 32, height: 32 }} />
                        Estamos comunicando com o eletroposto.
                    </>
                    :
                    <>
                        <>
                            {props.estacoes.map((s: EstacaoType) => {
                                const isAvailable = s?.status === 'LIVRE' || s?.status === 'ONLINE';    
                                return (
                                    <Button
                                        key={s?.id}
                                        onClick={() => { props.setEstacao(s); props.setIndex(0); }}
                                        style={{
                                            margin: 5, padding: 10, borderRadius: 5,
                                            display: 'flex', alignItems: 'center', gap: '10px', width: '100%',
                                            border: '1px solid #ccc', cursor: 'pointer'
                                        }}
                                        disabled={!isAvailable}
                                        severity={s?.id===props.estacao?.id ? undefined : 'secondary'}
                                    >
                                        
                                        <CardEstacao estacao={s} loadingStatus={loadingStatus} dark={s?.id===props.estacao?.id}/>
                                    </Button>
                                )
                            })}
                        </>
                    </>
                }
                <div>

                </div>
            </div>
        </div>
    )
}
export default Station;